import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const RoutedWhatsAppTemplates = lazy(() =>
  import("@scenes/MessageComposition/WhatsApp/WhatsAppTemplateLibrary").then((module) => ({
    default: module.WhatsAppTemplateLibrary,
  }))
);

export const engagementTemplatesAndMediaWhatsAppTemplatesNRO: NavigationRoutingObject = {
  section: "templates",
  Component: RoutedWhatsAppTemplates,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("engagement-templates-and-media-whats-app-templates-nro-heading", "WhatsApp Templates"),
  pageNameForTracking: () => "WhatsApp Templates",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("whats_app_template_builder") &&
      hasPermission("appGroup", { permission: "viewWhatsappMessageTemplates" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/templates_and_media/whats_app_templates/:appGroupId",
};
